/* istanbul ignore file */
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { vulnerabilityApi } from 'src/app/api/base';

const useAcceptRisk = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: ['accept-risk'],
    mutationFn: async ({ cve_id, ...params }: any) =>
      vulnerabilityApi(`/v1/vulnerabilities/${cve_id}/risk-acceptance`).post(
        params,
      ),
    onSuccess: (_, { cve_id }) => {
      queryClient.invalidateQueries({ queryKey: ['vulnerabilities'] });
      queryClient.invalidateQueries({ queryKey: ['vulnerability', cve_id] });
    },
  });
};

const useAcceptRiskUpdate = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: ['accept-risk-update'],
    mutationFn: async ({ cve_id, risk_acceptance_id, ...params }: any) =>
      vulnerabilityApi(
        `/v1/vulnerabilities/${cve_id}/risk-acceptance/${risk_acceptance_id}`,
      ).patch(params),
    onSuccess: (_, { cve_id }) => {
      queryClient.invalidateQueries({ queryKey: ['vulnerabilities'] });
      queryClient.invalidateQueries({ queryKey: ['vulnerability', cve_id] });
    },
  });
};

export { useAcceptRisk, useAcceptRiskUpdate };
